/**
 * @returns {import('@/types').QueryParams}
 */
const getQueryStringParameters = () => {
  const search = window.location.search.replace('?', '').split('&');
  /** @type {import('@/types').QueryParams} */
  let params = {};

  if (window.location.search.length > 0) {
    search.forEach((query) => {
      let parts = query.split('=');
      params[parts[0]] = parts[1] || '';
    });
  }

  return params;
}

/**
 * @param {string} param
 * @param {import('@/types').QueryParams} queryParamsObj
 * @param {string | null | undefined} [defaultValue]
 * @returns {string | null | undefined}
 */
const hasQueryParamOrNull = (param, queryParamsObj, defaultValue = null) => {
  return queryParamsObj.hasOwnProperty(param) ? decodeURI(queryParamsObj[param]) : defaultValue;
}

/**
 * @param {Record<string, string | number | boolean | undefined>} [parameters]
 * @returns {string}
 */
const generateQueryString = (parameters = {}) => {
  let queryString = "?";
  for(let key in parameters) {
    queryString = queryString + key + "=" + encodeURIComponent(String(parameters[key])) + "&";
  }
  return queryString.substring(0, queryString.length - 1);
}

/**
 * @param {import('@/types').FilterOption[] | import('@/types').GroupedOptions} options
 * @param {boolean[] | import('@/types').GroupedSelected} values
 * @returns {string}
 */
const joinFiltersSelectedValues = (options, values) => {
  if(Array.isArray(options) && Array.isArray(values)) {
    return options.filter((option, index) => {
      return values[index];
    }).map(option => option.value).join('|');
  } else {
    let groupedOptions = /** @type {import('@/types').GroupedOptions} */ (options);
    let groupedValues = /** @type {import('@/types').GroupedSelected} */ (values);
    return Object.keys(groupedOptions).map((key) => {
      return groupedOptions[key].filter((option, index) => {
        return groupedValues[key][index];
      }).map((option) => {
        return option.value;
      });
    }).flat().join('|');
  }
}

/**
 * @param {import('@/types').NavCategory[]} categories
 * @param {number} currentPage
 * @returns {import('@/types').NavCategory}
 */
const findCurrentNavCategory = (categories, currentPage) => {
  for(let i = 0; i < categories.length; i++) {
    if(categories[i].page === currentPage) {
      return categories[i];
    }
    if(categories[i].page > currentPage) {
      return categories[i - 1];
    }
  }
  return categories[categories.length - 1];
}

export {
  getQueryStringParameters,
  hasQueryParamOrNull,
  generateQueryString,
  joinFiltersSelectedValues,
  findCurrentNavCategory,
}
